import { render, staticRenderFns } from "./TopicManage.vue?vue&type=template&id=554160cc&scoped=true&"
import script from "./TopicManage.vue?vue&type=script&lang=js&"
export * from "./TopicManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554160cc",
  null
  
)

export default component.exports